import React, {useState} from "react";
import {FormControl, Select, MenuItem, InputLabel} from "@mui/material";
import {host} from "../libs/webRTC";
import axios from "../libs/httpClient";
import '../i18n';
import { useTranslation } from 'react-i18next';

export default function SubjectForm({setSubjectFormError = () => {}}){
    const [t, i18n] = useTranslation();
    const [subjects, setSubjects] = useState(null);
    const [subject, setChooseSubject] = useState('')
    const [subjectError, setSubjectError] = useState(true);
    
    
    if(subjects == null){
        axios.get(`${host}/subjects`).then((res) => {
            const subjectNames = res.data.map(e => e._id);
            if (subjectNames) setChooseSubject(subjectNames[0]);
            setSubjects(subjectNames);
        });
    }

    const handleSubjectChange = e => {
        console.log(e)
        if (e.target.value !== '') {
            setChooseSubject(e.target.value)
            setSubjectError(false);
            setSubjectFormError(false);
        } else {
            setSubjectError(true);
        }
    };

    return(
        <FormControl sx={{ width: '20vw' }}>
            <InputLabel>{t("Предмет")}</InputLabel>
            <Select
                value={subject}
                onChange={handleSubjectChange}
                autoWidth
                label={t("Предмет")}
                id="subject"
                error={subjectError}
            >
            {subjects === null 
                ? "..." 
                : subjects.map(e => (
                    <MenuItem key={subjects.indexOf(e)} value={e} sx={{ width: '20vw' }}>{e}</MenuItem>
                ))
            }
            </Select>
        </FormControl>
    )
}
